import HttpGlobal from "../Global/HttpGlobal.class";
import { customerApiBaseUrl } from "../../../native/nativeMode";

export interface ClientConsentsI {
  marketing: boolean;
  beneficiaryCommunications: boolean;
}

/**
 * Consentimientos del cliente de un alta del caller (paso `consents_pending` de
 * ms-agl, F3 «Caller IT al día»): los da el cliente con su enlace, nunca el
 * comercial. `POST /customer/leads/{ulid}/consents` del gateway; al guardarlos
 * el estado pasa a `legalnote_pending`.
 */
export default class HttpClientConsentsRepository extends HttpGlobal {
  recordClientConsents = async (consents: ClientConsentsI): Promise<unknown> =>
    this.generalPost({
      url: `${customerApiBaseUrl()}/customer/leads/${this.leadId}/consents`,
      dataRequest: consents,
    });
}
